import { definePath } from '../../router/definePath';

export const WatchPaths = {
  watch: definePath('public', { de: '/watch', en: '/watch' }),
} as const;
